import { useCallback, useEffect, useState } from 'react';
import { getVisitScheduleMatch } from './dashboardApi';
import type { VisitScheduleMatchPeriod } from './dashboardApi';
import { getWeekPeriodsForBaseDate, getTodayDateStringKST } from '@/shared/lib/dashboard/dateRange';

const WEEK_COUNT = 6;

export interface VisitScheduleMatchData {
  periods: VisitScheduleMatchPeriod[];
}

export function useVisitScheduleMatch(baseDateParam?: string) {
  const baseDate = baseDateParam ?? getTodayDateStringKST();
  const [data, setData] = useState<VisitScheduleMatchData | null>(null);
  const [error, setError] = useState<Error | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  const mutate = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const weekPeriods = getWeekPeriodsForBaseDate(baseDate, WEEK_COUNT);
      const result = await getVisitScheduleMatch(weekPeriods);
      setData(result);
    } catch (e) {
      setError(e instanceof Error ? e : new Error(String(e)));
    } finally {
      setIsLoading(false);
    }
  }, [baseDate]);

  useEffect(() => {
    mutate();
  }, [mutate]);

  return { data, error, isLoading, mutate };
}
